import { Suspense } from 'react';
import { Await, useRouteLoaderData } from 'react-router-dom';
import GroupManagementInvite from '../components/GroupManagementInvite.jsx'
import GroupManagementUsers from '../components/GroupManagementUsers.jsx'
import { GetCurrentInvite, ListUsersGroups } from '../repo/GroupsRepo.js'

export default function GroupManagementPage() {
  const { invite, users, groupId } = useRouteLoaderData('group-manage')

  return (
    <section className='pb-10'>
      <div className="container mx-auto lg:w-6xl ">
        <div className='flex flex-col w-full justify-between'>

          <div className="bg-slate-100 rounded-lg lg:mt-4 mx-4 my-4 p-4 text-center">
            <h1 className='text-center text-xl font-bold'>Gerenciar Bolão</h1>
            <a className='text-green-600 underline hover:no-underline text-sm' href={`/?group_id=${groupId}`}>Voltar</a>
          </div>

          <div className=' bg-slate-100 rounded-lg mx-4 mb-4 justify-between p-4'>
            <div>
              <div id="invite">
                <Suspense fallback={<p>Carregando...</p>}>
                  <Await resolve={invite}>
                    {(loadedInvite) => <GroupManagementInvite invite={loadedInvite} />}
                  </Await>
                </Suspense>
              </div>
            </div>
          </div>

          <div className=' bg-slate-100 rounded-lg mx-4 mb-4 justify-between p-4'>
            <div>
              <div id="users">
                <Suspense fallback={<p>Carregando...</p>}>
                  <Await resolve={users}>
                    {(loadedUsers) => <GroupManagementUsers groupId={groupId} users={loadedUsers} />}
                  </Await>
                </Suspense>
              </div>
            </div>
          </div>

          <div className="lg:mt-4 mx-4 my-4 p-4 text-center">
            <a className='text-green-600 underline hover:no-underline text-sm' href={`/?group_id=${groupId}`}>Voltar</a>
          </div>

        </div>
      </div>
    </section>
  );
}

async function loadCurrentInvite(groupID) {
  const response = await GetCurrentInvite(groupID)

  if (response.status === 400 || response.status === 404) {
    return response
  }

  const resData = await response.data

  if (resData.errors) {
    return null
  } else {
    return resData.data;
  }
}

async function loadUsers(groupID) {
  const response = await ListUsersGroups(groupID)

  if (response.status === 400 || response.status === 404) {
    return response
  }

  const resData = await response.data

  if (resData.errors) {
    return null
  } else {
    return resData;
  }
}

export async function loader({ params, request }) {
  return {
    invite: loadCurrentInvite(params.groupID),
    users: loadUsers(params.groupID),
    groupId: params.groupID
  }
}
